class flavorAssortment extends HTMLElement {
  constructor() {
    super();
    this.totalRequired = 0;
    this.selectedItems = 0;
    this.modal = null;
    this.yesButton = null;
    this.useCardLayout = false;
    this.defaultImage = null;

    this.svgIconActive = `
      <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" style="width: 35px; height: 35px;">
        <path d="m256 0c-141.386719 0-256 114.613281-256 256s114.613281 256 256 256 256-114.613281 256-256-114.613281-256-256-256zm0 317.214844c-33.808594 0-61.214844-27.40625-61.214844-61.214844s27.40625-61.214844 61.214844-61.214844 61.214844 27.40625 61.214844 61.214844-27.40625 61.214844-61.214844 61.214844zm0 0" fill="#fccf3f"></path>
        <path d="m256 0c-10.183594 0-20.222656.613281-30.097656 1.769531 127.199218 14.902344 225.902344 123.03125 225.902344 254.230469s-98.703126 239.328125-225.902344 254.230469c9.875 1.15625 19.914062 1.769531 30.097656 1.769531 141.386719 0 256-114.613281 256-256s-114.613281-256-256-256zm0 0" fill="#efa335"></path>
        <path d="m256.003906 0c-141.726562-.00390625-256.9375 116.007812-255.9960935 257.730469.2695315 41.125 10.2460935 79.945312 27.7421875 114.292969 5.980469 3.1875 13.28125 6.828124 23.566406 5.480468 43.523438-5.703125 22.476563-44.703125 61.394532-46.9375 39.785156-2.285156 40.941406 46.9375 75.054687 46.9375s34.113281-24.742187 68.226563-24.742187c10.765624 0 18.132812 2.464843 24.246093 5.835937 17.363281 9.574219 27.867188 28.117188 27.867188 47.945313v24.195312c0 10.574219 8.574219 19.144531 19.144531 19.144531 10.574219 0 19.144531-8.570312 19.144531-19.144531v-64.222656c0-10.378906 8.074219-19.21875 18.445313-19.589844 10.890625-.386719 19.84375 8.324219 19.84375 19.128907v26.492187c0 10.570313 8.570312 19.144531 19.144531 19.144531s19.144531-8.574218 19.144531-19.144531c0-9.355469 7.402344-17.039063 16.753906-17.382813.289063-.011718.582032-.019531.875-.03125 28.683594-1.058593 53.421876-20.433593 61.386719-48.011718 6.519531-22.578125 10.011719-46.441406 10.011719-71.121094 0-141.382812-114.613281-255.99609375-255.996094-256zm-.003906 345.511719c-49.445312 0-89.53125-40.085938-89.53125-89.53125 0-49.449219 40.085938-89.53125 89.53125-89.53125s89.53125 40.082031 89.53125 89.53125c0 49.445312-40.085938 89.53125-89.53125 89.53125zm0 0" fill="#fc4e51"></path>
        <path d="m502.464844 186.5625c-.0625-.214844-.117188-.429688-.175782-.644531-1.085937-3.816407-2.261718-7.59375-3.515624-11.332031-.078126-.230469-.148438-.464844-.222657-.691407-2.605469-7.691406-5.570312-15.214843-8.863281-22.5625-.101562-.226562-.199219-.457031-.300781-.683593-4.003907-8.859376-8.511719-17.4375-13.460938-25.71875-.332031-.558594-.652343-1.121094-.988281-1.675782-.328125-.539062-.667969-1.066406-1-1.601562-.75-1.214844-1.496094-2.433594-2.265625-3.632813-1.894531-2.953125-3.859375-5.855469-5.867187-8.71875-.347657-.496093-.683594-1-1.035157-1.496093-1.835937-2.578126-3.730469-5.113282-5.65625-7.621094-1.695312-2.207032-3.417969-4.394532-5.183593-6.542969-.574219-.699219-1.160157-1.390625-1.742188-2.082031-1.890625-2.253906-3.816406-4.480469-5.785156-6.664063-.9375-1.046875-1.890625-2.078125-2.84375-3.105469-2.144532-2.304687-4.3125-4.582031-6.539063-6.808593-.558593-.558594-1.132812-1.101563-1.695312-1.65625-.898438-.882813-1.789063-1.765625-2.699219-2.636719-1.972656-1.878906-3.980469-3.714844-6.011719-5.527344-2.550781-2.28125-5.132812-4.523437-7.773437-6.703125-.683594-.5625-1.382813-1.113281-2.074219-1.671875-2.5-2.015625-5.023437-4.003906-7.597656-5.925781-.769531-.578125-1.554688-1.132813-2.332031-1.703125-.878907-.640625-1.753907-1.292969-2.640626-1.925781-.09375-.066407-.191406-.128907-.285156-.195313-6.605468-4.683594-13.4375-9.066406-20.484375-13.117187-.746093-.429688-1.5-.835938-2.25-1.257813-1.046875-.589844-2.09375-1.1875-3.152343-1.761718-.777344-.425782-1.570313-.828126-2.351563-1.242188-1.042969-.550781-2.078125-1.113281-3.128906-1.648438-.722657-.371093-1.457031-.722656-2.183594-1.085937-4.820313-2.414063-9.71875-4.691406-14.707031-6.800781-1.257813-.53125-2.53125-1.042969-3.800782-1.554688-.664062-.265625-1.320312-.546875-1.984374-.808594-2.78125-1.097656-5.59375-2.128906-8.421876-3.128906-7.023437-2.488281-14.179687-4.695312-21.46875-6.570312-.996093-.253906-2.007812-.488282-3.011718-.734375-1.050782-.257813-2.097656-.523438-3.152344-.769531-3.222656-.742188-6.472656-1.40625-9.738281-2.027344-.921875-.175782-1.835938-.363282-2.761719-.53125-.085938-.011719-.171875-.027344-.257812-.042969-2.015626-.355469-4.039063-.691406-6.070313-1.003906-.929687-.140625-1.867187-.261719-2.796875-.390625-1.195312-.171875-2.382812-.351563-3.582031-.503906-1.859375-.234376-3.726563-.441407-5.597657-.640626-.28125-.027343-.554687-.066406-.832031-.09375-1.035156-.105468-2.078125-.183593-3.117187-.277343-1.121094-.097657-2.238282-.210938-3.363282-.296875-.171874-.015625-.347656-.019532-.519531-.035156-1.996093-.148438-3.996093-.277344-6.003906-.378907-.449219-.023437-.902344-.03125-1.355469-.050781-1.730468-.082031-3.46875-.15625-5.210937-.1992188-.851563-.0234374-1.707031-.0195312-2.558594-.03125-1.347656-.0195312-2.691406-.0507812-4.042969-.0507812-.007812 0-.015625 0-.019531 0-2.417969 0-4.828125.0390625-7.226563.109375-.578124.015625-1.152343.042969-1.726562.066406-1.878906.0625-3.753906.140625-5.621094.25-.5625.03125-1.125.070313-1.6875.105469-1.898437.121094-3.789062.257812-5.675781.421875-.515625.042969-1.03125.089844-1.542969.136719-1.882812.175781-3.761718.367187-5.628906.582031-.308594.03125-.613281.066406-.921875.105469 127.171875 14.921875 225.851563 123.039062 225.851563 254.222656 0 58.339844-19.53125 112.109375-52.390626 155.160156 1.417969.335938 2.890626.53125 4.414063.53125 10.574219 0 19.144531-8.570312 19.144531-19.144531 0-9.355469 7.402344-17.039063 16.753906-17.382813.289063-.011718.582032-.019531.875-.03125 28.484376-1.050781 53.070313-20.164062 61.207032-47.4375.097656-.332031.199218-.65625.292968-.984374.183594-.644532.363282-1.289063.542969-1.9375.328125-1.183594.648438-2.371094.960938-3.5625.171875-.65625.347656-1.3125.515625-1.96875.429687-1.691407.84375-3.386719 1.242187-5.089844.113281-.488282.21875-.980469.328125-1.472656.304688-1.355469.605469-2.714844.886719-4.078126.132813-.632812.265625-1.261718.390625-1.898437.316406-1.558594.617188-3.125.902344-4.699219.054687-.316406.117187-.628906.175781-.945312.3125-1.761719.601563-3.535156.878906-5.308594.089844-.582031.175781-1.164062.261719-1.75.21875-1.472656.425781-2.945312.621094-4.425781.058594-.4375.121094-.875.175781-1.3125.230469-1.851563.441406-3.707031.636719-5.570313.050781-.503906.097656-1.007812.144531-1.511718.148437-1.5.28125-3 .402344-4.507813.039062-.503906.082031-1.011719.121093-1.515625.140626-1.902344.261719-3.808594.359376-5.722656.019531-.351563.03125-.707032.046874-1.0625.078126-1.621094.140626-3.25.1875-4.882813.015626-.535156.03125-1.070312.042969-1.609375.042969-1.949218.074219-3.902344.074219-5.863281 0-.003906 0-.011719 0-.015625 0-24.066406-3.328125-47.355469-9.535156-69.4375zm0 0" fill="#ea3942"></path>
        <g fill="#ffe7cf">
          <path d="m465.59375 108.996094c-12.363281-1.066406-17.007812 12.089844-18.675781 20.074218-.726563 3.476563.457031 7.070313 3.113281 9.425782l6.484375 5.75c3.859375 3.425781 9.703125 3.304687 13.417969-.273438l10.890625-10.496094c-4.625-8.464843-9.714844-16.632812-15.230469-24.480468zm0 0"></path>
          <path d="m445.34375 315.980469c-13.253906-3.132813-18.019531 10.160156-19.660156 18.003906-.667969 3.191406.421875 6.488281 2.855468 8.648437l3.246094 2.878907c.90625-.183594 1.832032-.3125 2.785156-.347657.292969-.007812.582032-.019531.875-.03125 5.839844-.214843 11.511719-1.199218 16.917969-2.851562l6.488281-6.25c3.253907-3.136719 3.78125-8.25 1.046876-11.851562-2.359376-3.101563-6.675782-6.332032-14.554688-8.199219zm0 0"></path>
          <path d="m122.660156 139.828125c-2.164062-1.917969-3.128906-4.847656-2.539062-7.679687 1.457031-6.964844 5.691406-18.769532 17.460937-15.988282 6.996094 1.65625 10.832031 4.527344 12.925781 7.28125 2.425782 3.199219 1.960938 7.742188-.929687 10.527344l-10.710937 10.316406c-3.023438 2.917969-7.78125 3.015625-10.925782.226563zm0 0"></path>
          <path d="m227.554688 1.59375c-.488282 1.671875-.882813 3.289062-1.1875 4.757812-.902344 4.304688.566406 8.75 3.855468 11.667969l8.019532 7.117188c4.773437 4.234375 12.003906 4.085937 16.601562-.34375l16.265625-15.675781c2.367187-2.277344 3.652344-5.332032 3.769531-8.421876-6.234375-.457031-12.527344-.695312-18.875-.695312-9.617187 0-19.105468.550781-28.449218 1.59375zm0 0"></path>
          <path d="m293.667969 134.925781c-2.640625-2.339843-3.816407-5.910156-3.097657-9.367187 1.777344-8.492188 6.941407-22.894532 21.292969-19.496094 8.535157 2.019531 13.210938 5.519531 15.765625 8.878906 2.960938 3.898438 2.390625 9.441406-1.136718 12.835938l-13.058594 12.585937c-3.691406 3.554688-9.496094 3.675781-13.328125.273438zm0 0"></path>
          <path d="m393.480469 220.839844c9.128906 2.160156 14.125 5.90625 16.859375 9.496094 3.167968 4.171874 2.558594 10.097656-1.214844 13.730468l-13.964844 13.460938c-3.949218 3.800781-10.15625 3.929687-14.257812.292968 0 0-2.773438-40.609374 12.578125-36.980468zm0 0"></path>
          <path d="m87.113281 284.816406c-7.300781 5.757813-13.296875 7.371094-17.796875 7.308594-5.28125-.074219-9.617187-4.226562-10.125-9.484375l-.769531-8c-.796875-8.25 6.917969-14.976563 14.878906-12.667969 12.417969 3.597656 22.484375 16.007813 13.8125 22.84375zm0 0"></path>
          <path d="m20.945312 181.128906c5.394532.203125 12.648438-1.574218 21.578126-8.371094 10.039062-7.648437-4.371094-22.820312-15.015626-32.035156-5.910156 11.660156-10.941406 23.835938-15.035156 36.425782 2.132813 2.335937 5.121094 3.855468 8.472656 3.980468zm0 0"></path>
          <path d="m132.933594 227.136719c0-2.972657.214844-5.890625.625-8.746094-6.941406-8.148437-17.21875-15.476563-17.21875-15.476563-5.414063.859376-9.253906 5.738282-8.820313 11.203126l1.535157 19.335937c.414062 5.21875 4.605468 9.453125 9.839843 9.648437 3.890625.148438 8.945313-.945312 15.054688-4.902343-.65625-3.589844-1.015625-7.285157-1.015625-11.0625zm0 0"></path>
        </g>
      </svg>
    `;

    this.svgIconInactive = `
      <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" style="width: 35px; height: 35px;">
        <path d="m173.308594 256c0 45.597656 37.09375 82.691406 82.691406 82.691406s82.691406-37.09375 82.691406-82.691406-37.09375-82.691406-82.691406-82.691406-82.691406 37.09375-82.691406 82.691406zm82.691406-67.691406c37.324219 0 67.691406 30.367187 67.691406 67.691406s-30.367187 67.691406-67.691406 67.691406-67.691406-30.367187-67.691406-67.691406 30.367187-67.691406 67.691406-67.691406zm0 0"></path>
        <path d="m437.019531 74.980469c-48.351562-48.351563-112.640625-74.980469-181.019531-74.980469-61.285156 0-120.578125 21.992188-166.957031 61.929688-7.511719 6.46875 2.261719 17.847656 9.785156 11.367187 43.660156-37.59375 99.480469-58.296875 157.171875-58.296875 64.375 0 124.894531 25.066406 170.414062 70.589844 28.757813 28.757812 49.355469 63.503906 60.621094 101.429687-10.476562 3.609375-19.550781 10.382813-26.074218 19.589844-8.121094 11.460937-11.371094 25.410156-9.148438 39.285156 3.601562 22.460938 21.007812 39.902344 42.792969 44.007813-3.699219 26.035156-11.625 51.238281-23.40625 74.613281-3.589844-16.835937-18.578125-29.503906-36.472657-29.503906-20.558593 0-37.285156 16.726562-37.285156 37.285156v22.722656c0 12.289063-10 22.289063-22.289062 22.289063-12.289063 0-22.289063-10-22.289063-22.289063v-4.710937c0-20.558594-16.726562-37.285156-37.289062-37.285156-20.558594 0-37.285157 16.726562-37.285157 37.285156v44.277344c0 12.289062-10 22.289062-22.289062 22.289062s-22.289062-10-22.289062-22.289062v-44.277344c0-20.558594-16.726563-37.285156-37.285157-37.285156-20.5625 0-37.289062 16.726562-37.289062 37.285156v4.710937c0 12.289063-10 22.289063-22.289063 22.289063-12.289062 0-22.289062-10-22.289062-22.289063v-22.722656c0-20.5625-16.726563-37.285156-37.285156-37.285156-17.957032 0-32.988282 12.753906-36.507813 29.679687-16.851563-33.285156-25.765625-70.304687-25.765625-108.691406 0-60.195312 22.3125-117.832031 62.832031-162.289062 6.675781-7.324219-4.398437-17.445313-11.085937-10.105469-43.042969 47.226562-66.746094 108.453125-66.746094 172.394531 0 68.378906 26.628906 132.667969 74.980469 181.019531 48.351562 48.351563 112.640625 74.980469 181.019531 74.980469 63.902344 0 125.097656-23.675781 172.308594-66.671875 7.332031-6.671875-2.757813-17.777344-10.097656-11.089844-44.445313 40.472657-102.050782 62.761719-162.210938 62.761719-64.375 0-124.894531-25.066406-170.414062-70.589844-13.554688-13.554687-25.296876-28.441406-35.105469-44.363281 2.8125-2.335937 4.503906-5.832031 4.503906-9.75 0-12.289063 10-22.289063 22.289063-22.289063 12.289062 0 22.289062 10 22.289062 22.289063v22.722656c0 20.558594 16.726562 37.285157 37.285156 37.285157 20.5625 0 37.289063-16.726563 37.289063-37.285157v-4.710937c0-12.289063 10-22.289063 22.289062-22.289063 12.289063 0 22.289063 10 22.289063 22.289063v44.277344c0 20.5625 16.726562 37.285156 37.285156 37.285156 20.5625 0 37.289062-16.726563 37.289062-37.285156v-44.277344c0-12.289063 10-22.289063 22.289063-22.289063s22.285156 10 22.285156 22.289063v4.710937c0 20.558594 16.730469 37.285157 37.289063 37.285157 20.5625 0 37.289062-16.726563 37.289062-37.285157v-22.722656c0-12.289063 10-22.289063 22.289063-22.289063 12.289062 0 22.285156 10 22.285156 22.289063 0 3.886719 1.667969 7.359375 4.441406 9.699219-6.707031 10.9375-14.3125 21.378906-22.777343 31.203125-6.546876 7.601562 4.960937 17.226562 11.367187 9.789062 85.226563-98.953125 84.019531-250.957031-13.027344-348.007812zm29.605469 168.539062c-2.898438-18.089843 7.660156-35.566406 24.246094-41.917969 5.613281 24.453126 7.269531 49.386719 5.382812 73.332032-15.125-3.332032-27.105468-15.652344-29.628906-31.414063zm0 0"></path>
        <path d="m286.515625 54.863281c0-16.824219-13.6875-30.515625-30.515625-30.515625s-30.515625 13.691406-30.515625 30.515625c0 16.828125 13.6875 30.519531 30.515625 30.519531s30.515625-13.691406 30.515625-30.519531zm-46.03125 0c0-8.554687 6.960937-15.515625 15.515625-15.515625s15.515625 6.960938 15.515625 15.515625c0 8.558594-6.960937 15.519531-15.515625 15.519531s-15.515625-6.960937-15.515625-15.519531zm0 0"></path>
        <path d="m366.683594 196.839844c14.8125 0 26.863281-12.054688 26.863281-26.863282 0-14.8125-12.050781-26.863281-26.863281-26.863281s-26.863282 12.050781-26.863282 26.863281c0 14.808594 12.050782 26.863282 26.863282 26.863282zm0-38.726563c6.539062 0 11.863281 5.320313 11.863281 11.863281 0 6.539063-5.324219 11.859376-11.863281 11.859376-6.542969 0-11.863282-5.320313-11.863282-11.859376 0-6.542968 5.320313-11.863281 11.863282-11.863281zm0 0"></path>
        <path d="m90.605469 293.929688c0 15.371093 12.507812 27.878906 27.878906 27.878906s27.878906-12.507813 27.878906-27.878906c0-15.375-12.507812-27.878907-27.878906-27.878907s-27.878906 12.503907-27.878906 27.878907zm40.757812 0c0 7.101562-5.777343 12.878906-12.878906 12.878906s-12.878906-5.777344-12.878906-12.878906c0-7.101563 5.777343-12.878907 12.878906-12.878907s12.878906 5.777344 12.878906 12.878907zm0 0"></path>
        <path d="m128.164062 106.863281c-28.71875 0-52.082031 23.363281-52.082031 52.082031s23.363281 52.082032 52.082031 52.082032 52.082032-23.363282 52.082032-52.082032-23.363282-52.082031-52.082032-52.082031zm0 89.164063c-20.449218 0-37.082031-16.632813-37.082031-37.082032 0-20.445312 16.632813-37.082031 37.082031-37.082031 20.445313 0 37.082032 16.636719 37.082032 37.082031 0 20.449219-16.636719 37.082032-37.082032 37.082032zm0 0"></path>
      </svg>
      `;

    // Built-in inline icons for the per-group `icon` key (e.g. "icon": "cake").
    // Outline (line-art) style to match the donut. Drawn with stroke="currentColor"
    // and fill="none" so they inherit the pill's text color and flip black->white
    // when the pill is selected (.checked sets color:#fff). Sized 20px like the
    // donut. fill="none" is set per shape so the .checked `svg { fill:#fff }` rule
    // can't accidentally fill the outlines.
    this.svgCakeIcon = `
      <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" stroke-width="24" stroke-linecap="round" stroke-linejoin="round" style="width: 20px; height: 20px;">
        <path fill="none" d="M92 360 92 300 420 224 420 360Z"></path>
        <path fill="none" d="M92 332 420 332"></path>
        <circle fill="none" cx="360" cy="206" r="22"></circle>
        <path fill="none" d="M360 184q14 -20 34 -16"></path>
      </svg>
    `;

    this.svgCookieIcon = `
      <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" stroke-width="26" stroke-linecap="round" stroke-linejoin="round" style="width: 20px; height: 20px;">
        <circle fill="none" cx="256" cy="256" r="168"></circle>
        <circle fill="currentColor" stroke="none" cx="200" cy="210" r="20"></circle>
        <circle fill="currentColor" stroke="none" cx="316" cy="206" r="17"></circle>
        <circle fill="currentColor" stroke="none" cx="248" cy="306" r="20"></circle>
        <circle fill="currentColor" stroke="none" cx="328" cy="300" r="15"></circle>
      </svg>
    `;

    this.svgJarIcon = `
      <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" stroke-width="26" stroke-linecap="round" stroke-linejoin="round" style="width: 20px; height: 20px;">
        <rect fill="none" x="170" y="104" width="172" height="56" rx="16"></rect>
        <path fill="none" d="M158 168h196v220a30 30 0 0 1-30 30h-136a30 30 0 0 1-30-30z"></path>
        <path fill="none" d="M168 300h176"></path>
      </svg>
    `;
  }

  connectedCallback() {
    const jsonScript = this.querySelector('script[type="application/json"]');
    if (!jsonScript) return;

    let rawData;
    try { rawData = JSON.parse(jsonScript.textContent); } catch(e) { return; }

    if (rawData.groups && Array.isArray(rawData.groups) && rawData.groups.length > 0) {
      this._expandGroups(rawData.groups);
      return;
    }

    this.insertContent();
  }

  _expandGroups(groups) {
    const formId = this.dataset.formId || '';
    const cardLayoutTheme = this.dataset.cardLayoutTheme || '';
    const parent = this.parentNode;
    const existingSvg = this.querySelector('.flavor__swatch-label svg');
    const svgIcon = existingSvg ? existingSvg.outerHTML : this.svgIconInactive;
    // `icon` accepts a built-in name (inline SVG, recolors like the donut),
    // an image URL (rendered as <img>), or nothing (donut fallback).
    const builtinIcons = { cake: this.svgCakeIcon, cookie: this.svgCookieIcon, jar: this.svgJarIcon, donut: svgIcon };

    groups.forEach((group, idx) => {
      const groupKey = (group.key || `group_${idx}`).replace(/[^A-Za-z0-9_-]/g, '_');
      const groupIcon = (group.icon && builtinIcons[group.icon])
        ? builtinIcons[group.icon]
        : group.icon
          ? `<img class="flavor__swatch-icon-img" src="${String(group.icon).replace(/"/g, '&quot;')}" alt="" loading="lazy">`
          : svgIcon;
      const el = document.createElement('flavor-assortment');
      el.setAttribute('data-card-layout-theme', cardLayoutTheme);
      el.setAttribute('data-group-label', group.label || '');
      el.setAttribute('data-form-id', formId);

      const script = document.createElement('script');
      script.type = 'application/json';
      script.textContent = JSON.stringify(group);

      const wrapper = document.createElement('div');
      wrapper.id = `flavor-assortment-${groupKey}`;
      const safeLabel = (group.label || '').replace(/"/g, '&quot;');
      wrapper.innerHTML = `
        <div class="flavor">
          <input type="hidden" name="properties[flavors_${groupKey}]" required="" value="[]" form="${formId}" data-group-label="${safeLabel}">
          <div class="flavor__cta">
            <label class="flavor__label"></label>
            <div class="flavor__swatches">
              <div class="flavor__swatch-label">
                ${groupIcon}
                <span>0 selected</span>
              </div>
            </div>
          </div>
        </div>
      `;
      wrapper.querySelector('.flavor__label').textContent = group.label || '';

      el.appendChild(script);
      el.appendChild(wrapper);
      parent.insertBefore(el, this);
    });

    this.remove();
  }

  renderModal() {
    const sizeContainer = document.querySelector('.product-form__input--pill');

    this.totalRequired = parseInt(this.config.numb_product_item) || 1;
    // Size picker override only applies to single-group products.
    // Multi-group expanded elements (data-group-label set) use their own numb_product_item.
    if (!this.dataset.groupLabel && sizeContainer) {
      const sizeInput = sizeContainer.querySelectorAll('input[type="radio"]');
      for (let i = 0; i < sizeInput.length; i++) {
        if (sizeInput[i].checked && sizeInput[i].dataset.sizeValue) {
          this.totalRequired = parseInt(sizeInput[i].dataset.sizeValue);
          break;
        }
      }
    }

    const widgetHTML = this.useCardLayout
      ? `<div id="flavorList" class="flavor__grid"></div>`
      : `<table class="flavor__widget" cellspacing="0" cellpadding="0">
           <thead><tr class="flavor__row"><th class="flavor__column-header"></th><th class="flavor__column-header" flavor-name="true">${this.columnLabel}</th><th class="flavor__column-header">QUANTITY</th></tr></thead>
           <tbody id="flavorList" class="flavor__body"></tbody>
         </table>`;

    this.modal = document.createElement("div");
    this.modal.className = "flavor__modal";
    this.modal.style.display = "none";
    this.modal.innerHTML = `
      <div class="flavor__modal-overlay"></div>
      <div class="flavor__modal-content${this.useCardLayout ? ' flavor__modal-content--card' : ''}">
        <div class="flavor__modal-header">
          <span>${this.modalHeading ? this.modalHeading : `Please pick ${this.totalRequired > 1 ? "flavors" : "the flavor"} for your ${this.totalRequired > 1 ? this.totalRequired + " " + this.itemNamePlural : this.itemName}`}</span>
          <button id="modalClose" class="flavor__modal-close">
            <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 7L1.27 1.27 7 7l5.73-5.73L7 7zm0 0l5.73 5.73L7 7l-5.73 5.73L7 7z" stroke="#fff" stroke-width="3" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
            </svg>
          </button>
        </div>
        <div class="alert alert__error hidden">
          <div class="alert__text-container">
            <span id="flavorError" class="alert__text"></span>
          </div>
        </div>
        <div class="flavor__widget-container">
          ${widgetHTML}
        </div>
        <div class="flavor__modal-cta">
          <button type="button" class="button button--secondary button--full-width" data-cta="cancel">Cancel</button>
          <button type="button" class="button button--primary button--full-width disabled" disabled="" data-cta="confirm">Confirm</button>
        </div>
      </div>
    `;
    document.body.appendChild(this.modal);
  }

  insertContent() {
    // Support both the old single-group format { flavors: { ... } }
    // and the new per-group format { key, label, numb_product_item, options, ... }
    const jsonScript = this.querySelector('script[type="application/json"]');
    if (!jsonScript) return;
    this.data = JSON.parse(jsonScript.textContent);
    // Three supported formats:
    // 1. { flavors: [...], numb_product_item: N, item_name: "...", ... }  (array directly under flavors)
    // 2. { flavors: { options: [...], numb_product_item: N, ... } }        (nested object)
    // 3. { key: "X", options: [...], numb_product_item: N, ... }           (per-group, new format)
    if (Array.isArray(this.data.flavors)) {
      this.config = { ...this.data, options: this.data.flavors };
    } else {
      this.config = this.data.flavors || this.data;
    }

    const flavors = this.config.options || [];
    this.itemName = this.config.item_name || 'item';
    this.itemNamePlural = this.config.item_name_plural || 'items';
    this.limitExceededMsg = this.config.limit_exceeded_msg || null;
    this.incompleteQtyMsg = this.config.incomplete_qty_msg || null;
    this.premiumPrice = this.config.premium_price || '$2';
    this.deluxePrice = this.config.deluxe_price || '$4';
    this.defaultImage = this.config.default_image || null;
    this.modalHeading = this.config.modal_heading || null;
    this.columnLabel = this.config.column_label || 'FLAVOR';

    const themeEnabled = this.dataset.cardLayoutTheme === 'true';
    const productEnabled = this.config.card_layout === true;
    this.useCardLayout = themeEnabled && productEnabled;

    const trigger = this.querySelector(".flavor__swatch-label");
    if (!trigger) return;

    const allSoldOut = flavors.length === 0 || flavors.every(f => f.sold_out === true);
    if (allSoldOut) {
      const labelSpan = trigger.querySelector("span");
      if (labelSpan) labelSpan.textContent = "Unavailable";
      trigger.classList.add("flavor__swatch-label--unavailable");
      trigger.setAttribute("aria-disabled", "true");
      return;
    }

    let selected = {};

    trigger.addEventListener("click", () => {
      this.renderModal();
      const flavorList = this.modal.querySelector("#flavorList");
      this.yesButton = this.modal.querySelector('[data-cta="confirm"]');
      const errorMsg = this.modal.querySelector("#flavorError");
      const closeModal = this.modal.querySelector("#modalClose");

      this.modal.querySelector('.flavor__modal-cta').addEventListener('click', (e) => {
        if (!e.target.matches("button")) return;
        const inputOption = this.querySelector('input[type="hidden"]');
        const label = this.querySelector(".flavor__swatch-label span");

        if (e.target.dataset.cta == "confirm") {
          const inputs = [...this.modal.querySelectorAll('input[data-input="quantity"]:not(:disabled)')];

          const selectedFlavors = inputs.map(input => ({
            code: input.dataset.code,
            name: input.name,
            quantity: parseInt(input.value || 0),
            premium: input.dataset.premium === "true" ? true : false,
            deluxe: input.dataset.deluxe === "true" ? true : false
          })).filter(item => item.quantity > 0);

          inputOption.value = JSON.stringify(selectedFlavors);
          label.textContent = `${this.selectedItems} selected`;
          label.parentElement.classList.add("checked");
          this.modal.remove();
        } else if (e.target.dataset.cta == "cancel") {
          this.modal.remove();
        }
      });

      flavorList.innerHTML = "";
      selected = {};
      errorMsg.textContent = this.incompleteQtyMsg || `Please complete your flavor selection to reach a total of ${this.totalRequired} ${this.totalRequired != 1 ? this.itemNamePlural : this.itemName}.`;

      const classicFlavors = flavors.filter(f => !f.premium && !f.deluxe);
      const premiumFlavors = flavors.filter(f => f.premium && !f.deluxe);
      const deluxeFlavors = flavors.filter(f => f.deluxe);

      const renderFlavor = this.useCardLayout
        ? (flavor) => this.renderFlavorCard(flavor, selected, flavorList)
        : (flavor) => this.renderFlavorRow(flavor, selected, flavorList);

      classicFlavors.forEach(renderFlavor);

      if (premiumFlavors.length > 0) {
        if (this.useCardLayout) {
          const heading = document.createElement("div");
          heading.className = "flavor__section-heading";
          heading.innerHTML = `<span>Premium Flavors (+${this.premiumPrice} each)</span>`;
          flavorList.appendChild(heading);
        } else {
          const divider = document.createElement("tr");
          divider.className = "flavor__section-divider";
          divider.innerHTML = `<td colspan="3"><span>Premium Flavors (+${this.premiumPrice} each)</span></td>`;
          flavorList.appendChild(divider);
        }
        premiumFlavors.forEach(renderFlavor);
      }

      if (deluxeFlavors.length > 0) {
        if (this.useCardLayout) {
          const heading = document.createElement("div");
          heading.className = "flavor__section-heading flavor__section-heading--deluxe";
          heading.innerHTML = `<span>Deluxe Flavors (+${this.deluxePrice} each)</span>`;
          flavorList.appendChild(heading);
        } else {
          const divider = document.createElement("tr");
          divider.className = "flavor__section-divider flavor__section-divider--deluxe";
          divider.innerHTML = `<td colspan="3"><span>Deluxe Flavors (+${this.deluxePrice} each)</span></td>`;
          flavorList.appendChild(divider);
        }
        deluxeFlavors.forEach(renderFlavor);
      }

      this.modal.style.display = "flex";

      flavorList.addEventListener("click", (e) => {
        if (e.target.closest('.flavor__card--sold-out, .flavor__item--sold-out')) return;
        if (e.target.matches("button")) {
          const btn = e.target;
          const item = btn.closest('[data-flavor-item]');
          if (!item) return;
          const input = btn.parentElement.querySelector('[data-input="quantity"]');
          const code = input.dataset.code;
          const checkbox = item.querySelector('input[data-flavor="action"]');
          let value = parseInt(input.value);
          const currentTotal = Object.values(selected).reduce((a, b) => a + b, 0);

          if (btn.dataset.action == "increase") {
            if (item.classList.contains("disabled")) {
              if (currentTotal < this.totalRequired) {
                checkbox.checked = true;
                this.setItemActive(item, true);
                input.disabled = false;
                input._selectionHandler = () => this.updateSelection();
                input.addEventListener("change", input._selectionHandler);
                item.querySelectorAll("button").forEach((b) => { b.disabled = false; });
                errorMsg.parentElement.parentElement.classList.remove("hidden");
                input.value = 1;
                selected[code] = 1;
                input.dispatchEvent(new Event('change'));
              }
            } else if (currentTotal < this.totalRequired) {
              value++;
              selected[code] = value;
              input.value = value;
              input.dispatchEvent(new Event('change'));
            }
          } else if (btn.dataset.action == "decrease") {
            if (value > 1) {
              value--;
              selected[code] = value;
              input.value = value;
              input.dispatchEvent(new Event('change'));
            } else if (value === 1) {
              checkbox.checked = false;
              this.setItemActive(item, false);
              input.disabled = true;
              input.value = 0;
              if (input._selectionHandler) {
                input.removeEventListener("change", input._selectionHandler);
                input._selectionHandler = null;
              }
              item.querySelectorAll("button").forEach((b) => { b.disabled = true; });
              item.querySelector('[data-action="increase"]').disabled = false;
              selected[code] = 0;
              this.updateSelection();
            }
          }
        } else if (e.target.matches('input[data-flavor="action"]')) {
          const item = e.target.closest('[data-flavor-item]');
          if (!item) return;

          if (e.target.checked) {
            this.setItemActive(item, true);
            const activatedInput = item.querySelector('[data-input="quantity"]');
            activatedInput.disabled = false;
            activatedInput._selectionHandler = () => this.updateSelection();
            activatedInput.addEventListener("change", activatedInput._selectionHandler);
            item.querySelectorAll("button").forEach((btn) => { btn.disabled = false; });
            errorMsg.parentElement.parentElement.classList.remove("hidden");
            activatedInput.value = 1;
            selected[activatedInput.dataset.code] = 1;
            activatedInput.dispatchEvent(new Event('change'));
          } else {
            this.setItemActive(item, false);
            const deactivatedInput = item.querySelector('[data-input="quantity"]');
            deactivatedInput.disabled = true;
            deactivatedInput.value = 0;
            if (deactivatedInput._selectionHandler) {
              deactivatedInput.removeEventListener("change", deactivatedInput._selectionHandler);
              deactivatedInput._selectionHandler = null;
            }
            item.querySelectorAll("button").forEach((btn) => { btn.disabled = true; });
            item.querySelector('[data-action="increase"]').disabled = false;
            selected[e.target.name] = 0;
            errorMsg.parentElement.parentElement.classList.add("hidden");
          }

          e.target.addEventListener("change", () => this.updateSelection());
        } else {
          const card = e.target.closest('.flavor__card');
          if (card && card.classList.contains('disabled') && !card.classList.contains('flavor__card--sold-out') && !e.target.closest('.flavor__card-footer')) {
            card.querySelector('[data-action="increase"]').click();
          }
        }
      });

      closeModal.addEventListener("click", () => {
        this.modal.remove();
      });
    });
  }

  renderFlavorCard(flavor, selected, flavorList) {
    selected[flavor.code] = 0;

    const imgSrc = flavor.image || this.defaultImage || '';
    const fallbackSrc = (!flavor.image && this.defaultImage) ? '' : (this.defaultImage || '');

    const imgHTML = imgSrc
      ? `<img
           src="${imgSrc}"
           alt="${flavor.name}"
           class="flavor__card-img"
           loading="lazy"
           data-fallback="${fallbackSrc}"
           onerror="const f=this.dataset.fallback;if(f&&this.src!==f){this.src=f}else{this.closest('.flavor__card-media').classList.add('no-img')}"
         >`
      : '';

    const premiumImageBadge = flavor.deluxe
      ? `<span class="flavor__card-premium-img-badge flavor__card-deluxe-img-badge">+${this.deluxePrice}</span>`
      : flavor.premium
        ? `<span class="flavor__card-premium-img-badge">+${this.premiumPrice}</span>`
        : '';

    const premiumNameBadge = flavor.deluxe
      ? `<span class="flavor__premium-badge flavor__deluxe-badge">+${this.deluxePrice}</span>`
      : flavor.premium
        ? `<span class="flavor__premium-badge">+${this.premiumPrice}</span>`
        : '';

    const soldOut = flavor.sold_out === true;
    const soldOutBadge = soldOut ? '<span class="flavor__soldout-badge">Sold out</span>' : '';

    const card = document.createElement("div");
    card.className = `flavor__card disabled${flavor.deluxe ? ' flavor__card--deluxe' : flavor.premium ? ' flavor__card--premium' : ''}${soldOut ? ' flavor__card--sold-out' : ''}`;
    card.dataset.flavorItem = '';
    card.dataset.code = flavor.code;
    if (soldOut) card.setAttribute('aria-disabled', 'true');
    card.innerHTML = `
      <input type="checkbox" name="${flavor.code}" id="${flavor.code}" class="flavor__switch-input" data-flavor="action"${soldOut ? ' disabled' : ''}>
      <div class="flavor__card-media">
        ${imgHTML}
        ${premiumImageBadge}
        <div class="flavor__card-img-placeholder" aria-hidden="true">
          ${this.svgIconInactive}
        </div>
      </div>
      <div class="flavor__card-body">
        <span class="flavor__name">${flavor.name}</span>
        ${premiumNameBadge}
        ${soldOutBadge}
      </div>
      <div class="flavor__card-footer">
        <div class="flavor__input-quantity">
          <button type="button" class="flavor__button flavor__button--decrease" data-action="decrease" disabled>−</button>
          <input name="${flavor.name}" value="0" class="input-number__input" type="text" data-input="quantity" min="0" data-code="${flavor.code}" data-premium="${flavor.premium || false}" data-deluxe="${flavor.deluxe || false}" disabled>
          <button type="button" class="flavor__button flavor__button--increase" data-action="increase"${soldOut ? ' disabled' : ''}>+</button>
        </div>
      </div>
    `;
    flavorList.appendChild(card);
  }

  renderFlavorRow(flavor, selected, flavorList) {
    selected[flavor.code] = 0;
    const premiumBadge = flavor.premium
      ? `<span class="flavor__premium-badge">+${this.premiumPrice}</span>`
      : flavor.deluxe
        ? `<span class="flavor__premium-badge flavor__deluxe-badge">+${this.deluxePrice}</span>`
        : '';

    const soldOut = flavor.sold_out === true;
    const soldOutBadge = soldOut ? '<span class="flavor__soldout-badge">Sold out</span>' : '';

    const item = document.createElement("tr");
    item.className = `flavor__item disabled${soldOut ? ' flavor__item--sold-out' : ''}`;
    item.dataset.flavorItem = '';
    if (soldOut) item.setAttribute('aria-disabled', 'true');
    item.innerHTML = `
      <td class="flavor__column">
        <div class="flavor__switch">
          <input type="checkbox" name="${flavor.code}" id="${flavor.code}" class="flavor__switch-input" data-flavor="action"${soldOut ? ' disabled' : ''}>
          <label for="${flavor.code}" class="flavor__switch-label">
            <span class="flavor__switch-icon">
              ${this.svgIconInactive}
            </span>
          </label>
        </div>
      </td>
      <td class="flavor__column"><span class="flavor__name">${flavor.name}</span>${premiumBadge}${soldOutBadge}</td>
      <td class="flavor__column">
        <div class="flavor__input-quantity">
          <button type="button" class="flavor__button flavor__button--plus" data-action="decrease" disabled>-</button>
          <input name="${flavor.name}" value="0" class="input-number__input" type="text" data-input="quantity" min="0" data-code="${flavor.code}" data-premium="${flavor.premium || false}" data-deluxe="${flavor.deluxe || false}" disabled>
          <button type="button" class="flavor__button flavor__button--minus" data-action="increase"${soldOut ? ' disabled' : ''}>+</button>
        </div>
      </td>
    `;
    flavorList.appendChild(item);
  }

  setItemActive(item, active) {
    if (active) {
      item.classList.remove('disabled');
      if (this.useCardLayout) {
        item.classList.add('flavor__card--selected');
      } else {
        item.querySelector('.flavor__switch-label span').innerHTML = this.svgIconActive;
      }
    } else {
      item.classList.add('disabled');
      if (this.useCardLayout) {
        item.classList.remove('flavor__card--selected');
      } else {
        item.querySelector('.flavor__switch-label span').innerHTML = this.svgIconInactive;
      }
    }
  }

  updateSelection() {
    const errorMsg = this.modal.querySelector("#flavorError");

    let inputs = [...this.modal.querySelectorAll('input[data-input="quantity"]:not(:disabled)')];

    let selectedItems = inputs.filter(input => parseInt(input.value || 0) > 0);
    let totalQuantity = selectedItems.reduce((sum, input) => sum + parseInt(input.value), 0);

    this.selectedItems = totalQuantity;

    if (totalQuantity === this.totalRequired) {
      errorMsg.parentElement.parentElement.classList.add("hidden");
      this.yesButton.classList.remove("disabled");
      this.yesButton.disabled = false;
    } else {
      errorMsg.parentElement.parentElement.classList.remove("hidden");
      this.yesButton.classList.add("disabled");
      this.yesButton.disabled = true;
      if (totalQuantity > this.totalRequired) {
        errorMsg.textContent = this.limitExceededMsg || `You've exceeded the limit of ${this.totalRequired} ${this.totalRequired != 1 ? this.itemNamePlural : this.itemName}. Please select the flavors for a total of ${this.totalRequired} ${this.totalRequired != 1 ? this.itemNamePlural : this.itemName}.`;
      } else {
        errorMsg.textContent = this.incompleteQtyMsg || `Please complete your flavor selection to reach a total of ${this.totalRequired} ${this.totalRequired != 1 ? this.itemNamePlural : this.itemName}.`;
      }
    }
  }
}

customElements.define("flavor-assortment", flavorAssortment);
